import { __rest } from "tslib";
import { createElement } from 'rax';
import Checkbox from '../checkbox';
import { FieldElement } from '../field';
export default class CheckboxField extends FieldElement {
    renderPreview(value) {
        const _a = this.props, { direction = 'hoz' } = _a, others = __rest(_a, ["direction"]);
        return <Checkbox.Group value={value} style={{ maxWidth: '100%' }} direction={direction} disabled {...others}/>;
    }
    renderControl() {
        const _a = this.props, { direction = 'hoz' } = _a, others = __rest(_a, ["direction"]);
        return <Checkbox.Group style={{ maxWidth: '100%' }} direction={direction} {...others}/>;
    }
}
CheckboxField.displayName = 'CheckboxField';
